var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 128,
    viewBox: "0 0 148 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1121_4047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5295 64.9316V10.7618C11.5295 9.7641 11.9275 8.80728 12.6359 8.1018C13.3444 7.39633 14.3052 7 15.307 7H94.6731C95.6749 7 96.6357 7.39633 97.3442 8.1018C98.0526 8.80728 98.4506 9.7641 98.4506 10.7618V64.9316H66.0254V67.1761H43.9581V64.9316H11.5295Z",
    fill: "#CEE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9434 12.4854C12.9434 10.2762 14.7342 8.48535 16.9434 8.48535H92.8927C95.1019 8.48535 96.8927 10.2762 96.8927 12.4854V57.9752C96.8927 60.1844 95.1019 61.9752 92.8927 61.9752H16.9434C14.7342 61.9752 12.9434 60.1844 12.9434 57.9752V12.4854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.1531,
    y: 27.7266,
    width: 54.2728,
    height: 17.5588,
    rx: 2,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.0835,
    y: 34.5752,
    width: 34.8391,
    height: 3.95899,
    rx: 1.97949,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6926 37.6805L38.1344 36.0315C38.3784 35.1208 37.838 34.1848 36.9273 33.9408C36.0166 33.6967 35.0805 34.2372 34.8365 35.1479L33.7319 39.2702C33.4879 40.1809 34.0284 41.117 34.939 41.361C35.3572 41.473 35.7808 41.4197 36.1402 41.241C36.3608 41.1314 36.5572 40.9745 36.7134 40.7797M36.4855 35.5897L36.0436 37.2386C35.7996 38.1493 36.34 39.0854 37.2507 39.3294C38.1614 39.5734 39.0975 39.033 39.3415 38.1223L40.4461 34C40.6901 33.0893 40.1497 32.1532 39.239 31.9092C38.8208 31.7971 38.3972 31.8505 38.0378 32.0292C37.8172 32.1388 37.6208 32.2957 37.4646 32.4904",
    stroke: "#5283EC",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3174 64.5312H65.8174V65.0312V66.7796H44.8044V65.0312V64.5312H44.3044H7H6.5V65.0312V68.6588C6.5 69.7908 6.94968 70.8764 7.75013 71.6769C8.55057 72.4773 9.63621 72.927 10.7682 72.927H99.8536C100.986 72.927 102.071 72.4773 102.872 71.6769C103.672 70.8764 104.122 69.7908 104.122 68.6588V65.0312V64.5312H103.622H66.3174Z",
    fill: "#CEE7FF",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.4775,
    y: 7.99316,
    width: 46.3412,
    height: 87.9596,
    rx: 9.5,
    fill: "white",
    stroke: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8228,
    y: 9.33398,
    width: 43.6523,
    height: 85.2785,
    rx: 8,
    fill: "#19184A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.2549,
    y: 27.7266,
    width: 31.2699,
    height: 10.1167,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.8572,
    y: 31.6719,
    width: 20.0729,
    height: 2.28101,
    rx: 1.14051,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.369 11.2725C100.044 11.2725 99.7261 11.3686 99.4559 11.5488C99.1858 11.729 98.9752 11.9851 98.8509 12.2847C98.7265 12.5843 98.694 12.914 98.7574 13.232C98.8208 13.5501 98.9772 13.8423 99.207 14.0716C99.4367 14.3009 99.7294 14.4571 100.048 14.5203C100.367 14.5836 100.697 14.5511 100.997 14.427C101.297 14.3029 101.554 14.0927 101.734 13.8231C101.915 13.5535 102.011 13.2364 102.011 12.9121C102.011 12.4773 101.838 12.0602 101.53 11.7527C101.222 11.4452 100.804 11.2725 100.369 11.2725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1121_4047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.7513 33.4615L90.0058 32.5114C90.1464 31.9867 89.835 31.4474 89.3103 31.3068C88.7856 31.1662 88.2463 31.4776 88.1057 32.0023L87.4693 34.3774C87.3287 34.9021 87.6401 35.4415 88.1648 35.5821C88.4057 35.6466 88.6498 35.6159 88.8569 35.5129C88.9839 35.4498 89.0971 35.3594 89.1871 35.2472M89.0558 32.2569L88.8012 33.2069C88.6606 33.7316 88.972 34.271 89.4967 34.4115C90.0214 34.5521 90.5607 34.2408 90.7013 33.7161L91.3377 31.3409C91.4783 30.8162 91.167 30.2769 90.6423 30.1363C90.4013 30.0717 90.1573 30.1025 89.9502 30.2054C89.8231 30.2686 89.7099 30.359 89.6199 30.4712",
    stroke: "#5283EC",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.977 42.9396C108.977 39.9897 106.677 33.7704 98.0034 34.2488L98.0034 86.2071C98.0034 89.157 100.431 91.5484 103.426 91.5484H103.555C106.549 91.5484 108.977 89.157 108.977 86.2071V42.9396Z",
    fill: "#E28F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.528 60.9229H114.4C111.405 60.9229 108.977 63.3142 108.977 66.2641V86.1912C108.977 89.1411 111.405 91.5325 114.4 91.5325H114.528C117.523 91.5325 119.951 89.1411 119.951 86.1912V66.2641C119.951 63.3142 117.523 60.9229 114.528 60.9229Z",
    fill: "#E28F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.502 64.1475H125.374C122.379 64.1475 119.951 66.5388 119.951 69.4887V86.2079C119.951 89.1578 122.379 91.5492 125.374 91.5492H125.502C128.497 91.5492 130.925 89.1578 130.925 86.2079V69.4887C130.925 66.5388 128.497 64.1475 125.502 64.1475Z",
    fill: "#E28F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.819 67.2119H135.738C133.071 67.2119 130.909 69.3415 130.909 71.9685V86.7913C130.909 89.4183 133.071 91.5479 135.738 91.5479H135.819C138.486 91.5479 140.648 89.4183 140.648 86.7913V71.9685C140.648 69.3415 138.486 67.2119 135.819 67.2119Z",
    fill: "#E28F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.503 113.356L113.983 117.99C111.876 117.99 113.793 108.075 111.846 107.281C109.899 106.486 109.197 112.887 107.707 111.419C106.218 109.952 99.9667 110.152 99.1605 108.235C98.3542 106.318 97.9392 104.263 97.9392 102.188V89.3877H140.647L140.647 99.0033C140.631 103.17 140.817 108.2 133.459 112.339C130.469 115.287 125.733 113.336 121.503 113.356Z",
    fill: "#E28F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 105H105V136H133V105Z",
    fill: "#E28F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3246 70.1489L92.5575 99.3067C92.5575 99.3067 93.9118 103.602 96.6709 108.201C99.43 112.799 107.247 114.639 107.247 114.639L123.124 107.409L116.733 95.9991L126.284 87.6759L105.356 97.5556L93.3179 74.3028C93.3179 74.3028 89.356 68.4377 81.3246 70.1489Z",
    fill: "#E28F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.647 91.2825V81.801C140.647 80.5436 140.14 79.3378 139.238 78.4487C138.335 77.5597 137.111 77.0602 135.834 77.0602H135.738C134.462 77.0602 133.237 77.5597 132.335 78.4487C131.432 79.3378 130.925 80.5436 130.925 81.801V80.0153C130.925 79.3139 130.785 78.6193 130.512 77.9713C130.24 77.3232 129.84 76.7344 129.337 76.2384C128.833 75.7424 128.235 75.349 127.577 75.0806C126.92 74.8122 126.214 74.674 125.502 74.674H125.39C123.952 74.674 122.572 75.2367 121.555 76.2384C120.539 77.2401 119.967 78.5987 119.967 80.0153V78.435C119.963 77.017 119.388 75.6584 118.369 74.6572C117.349 73.656 115.968 73.0937 114.528 73.0938H114.416C112.979 73.0979 111.602 73.662 110.586 74.6628C109.57 75.6636 108.998 77.0197 108.993 78.435C108.993 77.0184 108.422 75.6599 107.405 74.6582C106.388 73.6565 105.009 73.0938 103.571 73.0938H103.442C102.003 73.0937 100.622 73.656 99.6021 74.6572C98.5826 75.6584 98.0077 77.017 98.0034 78.435V91.2825H140.647Z",
    fill: "#E28F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0658 45.619C54.3873 54.1859 81.4537 53.1907 89.5729 47.0552C90.0125 46.7518 94.6605 43.6909 94.5473 44.0593C93.5885 47.1814 89.8139 49.0141 88.6533 51.7991C87.4152 54.77 92.3103 46.395 94.808 44.642C95.7108 44.0083 92.4732 44.7378 92.0262 44.7929C89.3571 45.1221 87.0835 44.2802 84.6022 43.5181",
    stroke: "#5283EC",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1121_4047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 128,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1121_4047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.43791,
    height: 6.43791,
    fill: "white",
    transform: "translate(86.0942 29.5664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkImage);
export default __webpack_public_path__ + "static/media/linkImage.19e716f5b1b062ca14687d1d25423aad.svg";
export { ForwardRef as ReactComponent };